var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgComment = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;}\r\n\t.st1{display:none;}\r\n\t.st2{display:inline;}\r\n\t.st3{fill:none;stroke:#CECECE;stroke-width:0.1;stroke-miterlimit:10;}\r\n\t.st4{fill:#000000;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bounding_box"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    className: "st0",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "design"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M15.25,20H2.75C2.34,20,2,19.66,2,19.25v-8.5C2,7.03,5.03,4,8.75,4h6.5C18.97,4,22,7.03,22,10.75v2.5 C22,16.97,18.97,20,15.25,20z M3.5,18.5h11.75c2.89,0,5.25-2.36,5.25-5.25v-2.5c0-2.9-2.36-5.25-5.25-5.25h-6.5 c-2.89,0-5.25,2.35-5.25,5.25V18.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M8,13c-0.26,0-0.52-0.11-0.71-0.29C7.11,12.52,7,12.26,7,12c0-0.27,0.11-0.52,0.29-0.71 c0.37-0.37,1.05-0.37,1.42,0c0.04,0.05,0.08,0.1,0.12,0.15c0.04,0.06,0.07,0.12,0.09,0.18c0.03,0.06,0.05,0.12,0.06,0.18 C8.99,11.87,9,11.94,9,12s-0.01,0.13-0.02,0.2c-0.01,0.06-0.03,0.12-0.06,0.18c-0.02,0.06-0.05,0.12-0.09,0.17 c-0.04,0.06-0.08,0.11-0.12,0.16C8.52,12.89,8.26,13,8,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M12,13c-0.13,0-0.26-0.03-0.38-0.08c-0.13-0.05-0.23-0.12-0.33-0.21C11.11,12.52,11,12.26,11,12 c0-0.13,0.03-0.26,0.08-0.38c0.05-0.13,0.12-0.23,0.21-0.33c0.1-0.09,0.2-0.16,0.33-0.21c0.18-0.08,0.38-0.1,0.57-0.06 c0.07,0.01,0.13,0.03,0.19,0.06c0.06,0.02,0.12,0.05,0.17,0.09c0.06,0.03,0.11,0.08,0.16,0.12c0.09,0.1,0.16,0.2,0.21,0.33 C12.97,11.74,13,11.87,13,12c0,0.26-0.11,0.52-0.29,0.71c-0.05,0.04-0.1,0.09-0.16,0.12c-0.05,0.04-0.11,0.07-0.17,0.09 c-0.06,0.03-0.12,0.05-0.19,0.06C12.13,12.99,12.06,13,12,13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M16,13c-0.06,0-0.13-0.01-0.19-0.02c-0.07-0.01-0.13-0.03-0.19-0.06c-0.06-0.02-0.12-0.05-0.18-0.09 c-0.05-0.04-0.1-0.08-0.15-0.12C15.11,12.52,15,12.27,15,12c0-0.13,0.03-0.26,0.08-0.38c0.05-0.12,0.12-0.23,0.21-0.33 c0.05-0.04,0.1-0.08,0.15-0.12c0.06-0.04,0.12-0.07,0.18-0.09c0.06-0.03,0.12-0.05,0.19-0.06c0.32-0.06,0.66,0.04,0.9,0.27 C16.89,11.48,17,11.74,17,12c0,0.06-0.01,0.13-0.02,0.2c-0.01,0.06-0.03,0.12-0.06,0.18c-0.02,0.06-0.05,0.12-0.09,0.18 c-0.04,0.05-0.08,0.1-0.12,0.15C16.52,12.89,16.26,13,16,13z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgComment, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Comment.3cfc2d07.svg";
export { ForwardRef as ReactComponent };